import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuBarComponent } from "../../core/components/menu-bar/menu-bar.component";
import { ImageCarouselComponent } from "../../core/components/image-carousel/image-carousel.component";
import { FooterComponent } from "../../core/components/footer/footer.component";
import { Project } from '../../core/interfaces/Project';
import { combineLatest } from 'rxjs';
import { BackendService } from '../../core/services/backend.service';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'app-projects',
  imports: [MenuBarComponent, ImageCarouselComponent, FooterComponent, NgxTolgeeModule],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss'
})
export class ProjectsComponent {

  carouselItems: Project[] = [];
  project: Project | undefined;

  constructor(private route: ActivatedRoute, private router: Router, private backendService: BackendService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    combineLatest([
      this.backendService.getProjects(),
      this.route.paramMap
    ]).subscribe(([items, params]) => {
      const fetchedProjects : Project[] = items.data;
      const slug = params.get('slug');
      // Matched on the slug, not the title: titles come back localised, so a
      // title-keyed URL resolved only in the language it was copied from and
      // switching language on this page left every field blank.
      this.project = fetchedProjects.find(item => item.slug === slug);
      window.scrollTo({ top: 0, behavior: 'instant' });
      //set carouselItems except the current project
      this.carouselItems = fetchedProjects.filter(item => item.slug !== slug);
    });
  }
}
